import React from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';

import type { PaymentErrorDialogCopy } from '@src/features/payments/errors/hooks/usePaymentErrorDialog';

import { ErrorDialog } from './styles';

const DIALOG_WIDTH = '402px';

type PaymentErrorDialogProps = {
  copy: PaymentErrorDialogCopy;
  onRetry: () => void;
  onPayWithPix: () => void;
};

export const PaymentErrorDialog = (props: PaymentErrorDialogProps) => {
  const { copy, onRetry, onPayWithPix } = props;

  return (
    <ErrorDialog
      open
      width={DIALOG_WIDTH}
      data-testid='payment-error-dialog'
      title={copy.title}
      description={copy.body}
      onConfirm={onPayWithPix}
      onCancel={onRetry}
      slotProps={{
        modalHeader: { iconTitle: <IconAlertTriangle size={24} aria-hidden />, onClose: onRetry },
        modalActions: {
          divider: false,
          primaryButtonLabel: copy.primaryLabel,
          primaryButtonIcon: <></>,
          secondaryButtonIcon: null,
          ...(copy.secondaryLabel ? { secondaryButtonLabel: copy.secondaryLabel } : { secondaryButton: null }),
        },
      }}
    />
  );
};

export default PaymentErrorDialog;
